import type { FC, ReactNode } from "react";
import { cn } from "../../lib/utils";
import { Text } from "../../primitives";
import { trackingAttrs } from "../../utils";

export type SideAnchoredTextBlockProps = {
	text: ReactNode;
	className?: string;
	testId?: string;
	trackingId?: string;
};

/**
 * Body copy set beside a hairline rule. The rule marks the text as supporting
 * detail rather than a labeled field.
 */
export const SideAnchoredTextBlock: FC<SideAnchoredTextBlockProps> = ({
	text,
	className,
	testId = "side-anchored-text",
	trackingId,
}) => (
	<div
		className={cn("relative flex items-center", className)}
		data-testid={testId}
		{...trackingAttrs(trackingId)}
	>
		<div className="absolute top-0 bottom-0 left-0 w-[2px] rounded-full bg-bc-default" />
		<Text type="body" color="tertiary" className="flex pl-[15px]">
			{text}
		</Text>
	</div>
);
